import React from 'react';
import { UpdatePaymentMethodFormWithCheckboxAndHints } from '../components';
const UpdatePaymentMethodFlowForm = () => (React.createElement(UpdatePaymentMethodFormWithCheckboxAndHints, { isUpdatePaymentMethodFlow: true }));
export default UpdatePaymentMethodFlowForm;
